export default {"src":"/_next/static/media/down-small--format.a885aa62.svg","height":8,"width":12};